const KEYS = {
  votes: 'simimovies.activity.votes.v1',
  suggestions: 'simimovies.activity.suggestions.v1',
  reviews: 'simimovies.activity.reviews.v1',
};

function safeParse(json) {
  try {
    return JSON.parse(json);
  } catch {
    return null;
  }
}

function load(key) {
  if (typeof window === 'undefined') return [];
  const raw = window.localStorage.getItem(key);
  const parsed = raw ? safeParse(raw) : null;
  return Array.isArray(parsed) ? parsed : [];
}

function save(key, list) {
  window.localStorage.setItem(key, JSON.stringify(list));
}

export function addVote({ baseTitle, altTitle, rating, reason }) {
  const list = load(KEYS.votes);
  const entry = {
    id: `vote-${Date.now()}-${Math.random().toString(16).slice(2)}`,
    baseTitle,
    altTitle,
    rating,
    reason: reason || '',
    createdAt: new Date().toISOString(),
  };
  save(KEYS.votes, [entry, ...list].slice(0, 500));
}

export function addSuggestion({ baseTitle, suggestedTitle, reason, status = 'pending' }) {
  const list = load(KEYS.suggestions);
  const entry = {
    id: `sugg-${Date.now()}-${Math.random().toString(16).slice(2)}`,
    baseTitle,
    suggestedTitle,
    reason: reason || '',
    status,
    createdAt: new Date().toISOString(),
  };
  save(KEYS.suggestions, [entry, ...list].slice(0, 500));
}

export function addReview({ title, rating, text }) {
  const list = load(KEYS.reviews);
  const entry = {
    id: `rev-${Date.now()}-${Math.random().toString(16).slice(2)}`,
    title,
    rating,
    text: text || '',
    createdAt: new Date().toISOString(),
  };
  save(KEYS.reviews, [entry, ...list].slice(0, 500));
}

